import { render, staticRenderFns } from "./CategorySeoSettings.vue?vue&type=template&id=70891e32&scoped=true"
import script from "./CategorySeoSettings.vue?vue&type=script&lang=js"
export * from "./CategorySeoSettings.vue?vue&type=script&lang=js"
import style0 from "./CategorySeoSettings.vue?vue&type=style&index=0&id=70891e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70891e32",
  null
  
)

export default component.exports